import Countdown, {zeroPad} from 'react-countdown'
import GradientBox from 'react-scale/components/pages/transformx/common/gradient-box';

type rendererType = {
  hours: number;
  minutes: number;
  seconds: number;
}

const CountdownComponent = () => {
   const renderer = ({ hours, minutes, seconds }: rendererType) => (
      <div className="flex items-start justify-center max-w-full mt-10 space-x-3 lg:justify-between">
        <div className="space-y-4">
            <GradientBox className="w-[72px] h-[72px]">
              <p className="text-3xl tracking-[8px] text-center max-w-full leading-[48px]">{zeroPad(hours)}</p>
            </GradientBox>
            <p className="mx-auto text-sm max-w-max">Hours</p>
        </div>
        <span className="h-[72px] flex items-center"><p className="text-3xl font-extrabold text-gray-600 max-h-min">:</p></span>
        <div className="space-y-4">
            <GradientBox className="w-[72px] h-[72px]">
              <p className="text-3xl tracking-[8px] text-center max-w-full leading-[48px]">{zeroPad(minutes)}</p>
            </GradientBox>
            <p className="mx-auto text-sm max-w-max" max-w-max mx-auto>Minutes</p>
        </div>
        <span className="h-[72px] flex items-center"><p className="text-3xl font-extrabold text-gray-600 max-h-min">:</p></span>
        <div className="space-y-4">
            <GradientBox className="w-[72px] h-[72px]">
              <p className="text-3xl tracking-[8px] text-center max-w-full leading-[48px]">{zeroPad(seconds)}</p>
            </GradientBox>
            <p className="mx-auto text-sm max-w-max">Seconds</p>
        </div>
      </div>
    )

   return <Countdown date={Date.now() + 8000000} renderer={renderer} zeroPadTime={2} />
}

export default CountdownComponent
